import React from 'react'
import {Box,Button,Grid,IconButton} from "@mui/material"
import { Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const data = [
    {
        id:'1',
        title:'All Cuisines',
        bg:'#f0faf9',
        borderClr:'#559a95'
    },
    {
        id:'2',
        title:'Guamanuan',
        bg:'white',
        borderClr:'#9EA3AE'
    },
    {
        id:'3',
        title:'Puerto RIco',
        bg:'white',
        borderClr:'#9EA3AE'
    },
    {
        id:'4',
        title:'American Vegetable',
        bg:'white',
        borderClr:'#9EA3AE'
    },
    {
        id:'5',
        title:'Doughnuts',
        bg:'white',
        borderClr:'#9EA3AE'
    },
    {
        id:'6',
        title:'Doughnuts',
        bg:'white',
        borderClr:'#9EA3AE'
    },

];


const TabsBtn = () => {
  return (
    <Box sx={{mb:'10px'}}>
        <Box sx={{
            display:'flex',
            flexDirection:'row',
            alignItems:{lg:'center',md:'start',sm:'start',xs:'start'},
            justifyContent:'space-between'
        }}>
            <Box>
                <Grid container spacing={1}>
                
                {
                    data && data.map((v,i)=>{
                        return(
                            <>  
                            <Grid item lg={2} md={3}>
                            <Button sx={{
                                width:'150px',
                                height:'30px',
                                border:`1px solid ${v.borderClr}`,
                                borderRadius:'20px',
                                display:'flex',
                                flexDirection:'row',
                                justifyContent:'center',
                                alignItems:'center',
                                background:`${v.bg}`
                            }}>
                                <Box>
                                    <Typography sx={{color:`${v.borderClr}`,fontSize:'12px'}}>{v.title}</Typography>
                                </Box>
                            </Button>
                            </Grid>
                            </>
                        )
                    })
                }
                </Grid>
            </Box>
            <Box>
            <IconButton aria-label="arrow">
                <ArrowForwardIcon sx={{color:'#559a95'}}/>
            </IconButton>
            </Box>
        </Box>
    </Box>
  )
}

export default TabsBtn
